import React from 'react'
import { useNavigate } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  size: Yup.string().trim().required('Size is required'),
})

const Add = () => {
  const navigate = useNavigate()

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = axiosAuthInstance.post('size/add', {
        size: values.size,
      })
      if (response) {
        navigate('/size')
      }
    } catch (error) {
      console.log(error)
    }
  }
  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      size: '',
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='size'
          label='Size'
          placeholder='Size'
          required
          component={CustomInput}
        />

        <button
          type='submit'
          disabled={formik.isSubmitting}
          // onClick={addItem}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Add
        </button>
      </form>
    </FormikProvider>
  )
}

export default Add
